// extracted by mini-css-extract-plugin
export default {"modal_controle_body":"controle_acesso_modal_controle_body__wHnJR","warning_text":"controle_acesso_warning_text__zOtia","box":"controle_acesso_box__5p9Mn"};